import React, { useState } from "react";
import {
    Container,
    Col,
    Row,
    Image,
    Card,
    Button,
    Form,
    Dropdown
} from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import HeaderMobile from "../../reusableComps/HeaderMobile/HeaderMobile";

import CalendarIcon from '../../../assets/icons/calendar_today.svg';
import WarningIcon from '../../../assets/icons/Warning.svg';
import HelpCircleIcon from '../../../assets/icons/HelpCircle.svg';
import FileTextIcon from '../../../assets/icons/FileText.svg';
import TrashCanIcon from '../../../assets/icons/TrashIconWhite.svg';
import PlusIcon from '../../../assets/icons/PlusCircle.svg';
import UserPlusIcon from '../../../assets/icons/UserPlus.svg';

const RequestAbsences = () => {
    const [absenceType, setAbsenceType] = useState("Doença");
    const [note, setNote] = useState("");
    const [attachments, setAttachments] = useState([]);
    const navigate = useNavigate();

    const handleFileUpload = (e) => {
        const files = Array.from(e.target.files);
        setAttachments((prev) => [...prev, ...files]);
    };

    const handleRemoveAttachment = (index) => {
        setAttachments((prev) => prev.filter((_, i) => i !== index));
    };

    const _handleSubmit = () => {
        navigate("/absences");
    };

    return (
        <div style={{ background: 'linear-gradient(20deg, rgba(30, 3, 66, 1) 20%, rgb(6, 141, 199) 80%)', height: "100vh", overflowY: "auto" }}>
            <Container>
                <Row className='mb-2 d-flex justify-content-center'>
                    <Col className='col-12 mb-2'>
                        <Row>
                            <Col className='mt-1'></Col>
                            <HeaderMobile
                                showArrow={true}
                                showEdit={false}
                                showDelete={true}
                                onDelete={() => alert("Deleted!")}
                                onEdit={() => alert("Edit!")}
                            >
                                Pedir Ausência
                            </HeaderMobile>
                            <Col className='mt-1'></Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="mb-2">
                    <Col>
                        <span style={{ fontSize: "4vmin" }} className="text-white">Intervalo de Datas</span>
                    </Col>
                </Row>
                <Row className="mb-2">
                    <Col>
                        <Card style={{ backgroundColor: "#17296B", height: "10vmin" }} className="rounded-3">
                            <Row className="d-flex justify-content-between align-items-center text-white m-1">
                                <Col className="col-auto d-flex align-items-center">
                                    <span style={{ fontSize: "4vmin" }}>12 - 15 mar 2025</span>
                                </Col>
                                <Col className="col-auto">
                                    <Image src={CalendarIcon} style={{ width: "100%", height: "5vmin" }}></Image>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Row className="mb-2">
                    <Col>
                        <Card style={{ backgroundColor: "#17296B", height: "15vmin" }} className="rounded-3">
                            <Row className="d-flex align-items-center text-white m-1 mt-2">
                                <Col className="col-6 d-flex align-items-center">
                                    <Image src={WarningIcon} className="me-2" />
                                    <span style={{ fontSize: "3.7vmin" }}>Tipo de Ausência:</span>
                                </Col>
                                <Col className="col-6">
                                    <Dropdown>
                                        <Dropdown.Toggle
                                            id="dropdown-basic"
                                            className="border-0 rounded-3 w-100 d-flex justify-content-between align-items-center"
                                            style={{
                                                backgroundColor: "#1E0342",
                                                fontSize: "0.9rem"
                                            }}
                                        >
                                            <span>{absenceType}</span>
                                            <span className="dropdown-arrow"></span>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="border-0" style={{ backgroundColor: "#1E0342" }}>
                                            <Dropdown.Item className="text-white" onClick={() => setAbsenceType("Doença")}>Doença</Dropdown.Item>
                                            <Dropdown.Item className="text-white" onClick={() => setAbsenceType("Consulta")}>Consulta</Dropdown.Item>
                                            <Dropdown.Item className="text-white" onClick={() => setAbsenceType("Outro")}>Outro</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col>
                        <Card style={{ backgroundColor: "#17296B" }} className="rounded-3">
                            <Row className="d-flex justify-content-center">
                                <Col className="col-11 m-2">
                                    <Form>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                            <Form.Label className="text-white"><Image src={HelpCircleIcon}></Image> Nota</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={4}
                                                style={{ backgroundColor: "#1E0342", color: "white" }}
                                                className="border-0"
                                                value={note}
                                                onChange={(e) => setNote(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Card style={{ backgroundColor: "#17296B" }} className="rounded-3">
                            <Row className="d-flex justify-content-between align-items-center">
                                <Col className="col-auto m-2">
                                    <Image className="mb-2" src={FileTextIcon} />
                                    <span className="text-white"> Anexos</span>
                                </Col>
                                <Col className="col-auto">
                                    <label htmlFor="file-upload" style={{ cursor: "pointer" }}>
                                        <Image src={PlusIcon} style={{ width: "45%" }} />
                                    </label>
                                    <input
                                        id="file-upload"
                                        type="file"
                                        multiple
                                        style={{ display: "none" }}
                                        onChange={handleFileUpload}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div style={{ backgroundColor: "#1E0342", height: "25vh", paddingTop: "0.8rem" }} className="mb-3 mx-3 rounded-3">
                                        {attachments.map((file, index) => (
                                            <Card key={index} style={{ backgroundColor: "#17296B", height: "20%" }} className="mx-3 mb-2 d-flex">
                                                <Row className="mt-2 mx-1">
                                                    <Col className="col-2 d-flex justify-content-center">
                                                        <Image src={FileTextIcon} style={{ width: "90%" }} />
                                                    </Col>
                                                    <Col className="col-8 d-flex justify-content-center">
                                                        <b className="text-white">{file.name}</b>
                                                    </Col>
                                                    <Col className="col-2 d-flex justify-content-center">
                                                        <Image
                                                            src={TrashCanIcon}
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => handleRemoveAttachment(index)}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Card>
                                        ))}
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Row className="mt-5">
                    <Col className="d-flex justify-content-center">
                        <Button
                            className="border-0 rounded-3"
                            style={{ backgroundColor: "#17296B" }}
                            onClick={() => {
                                navigate("/absences");
                            }}
                        >
                            <Image className="mb-1" src={UserPlusIcon}></Image>
                            <span>Pedir Ausência</span>
                        </Button>

                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default RequestAbsences;